import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";

import { FakturagodkendelseModal } from "../fakturagodkendelse-modal/fakturagodkendelse.modal";
import { FakturaStatus } from "../model/faktura-status.model";
import { Faktura } from "../model/faktura.model";
import { FakturagodkendelseEvent, FakturagodkendelseEventArgs } from "../model/fakturagodkendelse-event.model";

@Component({
    selector: "fakturagodkendelse-liste",
    templateUrl: "./fakturagodkendelse-liste.component.html",
    styleUrls: ["./fakturagodkendelse-liste.component.scss"]
})
export class FakturagodkendelseListeComponent {
    public fullyExpanded = false;
    public working: boolean;
    public faktura: Faktura = null;

    @Input()
    public fakturaer: Faktura[] = [];

    @Input()
    public onGodkend: FakturagodkendelseEvent;

    @Input()
    public onAfvis: FakturagodkendelseEvent;

    @Output()
    public dokumentUrlerNeeded: EventEmitter<Faktura> = new EventEmitter();

    constructor(private readonly modal: FakturagodkendelseModal) {}

    public erAktiv(faktura?: any): boolean {
        return (faktura && faktura === this.faktura) || (!faktura && !!this.faktura);
    }

    public open(faktura: any): void {
        // Vi venter lige lidt med at vise detalje-panelet, da det ellers ser lidt
        // funky ud i mobile-visning (glider nedad i åbnende dialog).
        setTimeout(() => (this.fullyExpanded = true), 250);

        this.faktura = faktura;
        if (faktura && !faktura.dokumentUrler) {
            this.dokumentUrlerNeeded.emit(faktura);
        }
    }

    public close(faktura: any): void {
        this.fullyExpanded = false;

        if (this.faktura === faktura || !faktura) {
            this.faktura = null;
        }
    }

    public onButtonToggleGroupChange(event: MatButtonToggleChange, faktura: Faktura): void {
        event.source.buttonToggleGroup.value = null;
        switch (event.value) {
            case "afvent":
                this.afvent(faktura);
                break;
            case "afvis":
                this.aabnAfvisModal(faktura);
                break;
            case "godkend":
                this.aabnGodkendModal(faktura);
                break;
        }
    }

    public afvent(faktura: Faktura): void {
        this.aabnNaesteFaktura(faktura);
    }

    public aabnGodkendModal(faktura: Faktura): void {
        this.modal.open({
            status: FakturaStatus.Godkendt,
            faktura,
            titel: "Godkend faktura",
            successBesked: "Fakturaen er blevet godkendt",
            fejlBesked: "Kunne ikke godkende fakturaen",
            bemaerkning: faktura.bemaerkning,
            onOk: (args: FakturagodkendelseEventArgs) => this.onGodkend(args),
            onOkSucceeded: () => this.aabnNaesteFakturaOgFjernAktuelleFakturaFraListen(faktura)
        });
    }

    public aabnAfvisModal(faktura: Faktura): void {
        this.modal.open({
            status: FakturaStatus.Afvist,
            faktura,
            titel: "Afvis faktura",
            successBesked: "Fakturaen er blevet afvist",
            fejlBesked: "Kunne ikke afvise fakturaen",
            bemaerkning: faktura.bemaerkning,
            onOk: (args: FakturagodkendelseEventArgs) => this.onAfvis(args),
            onOkSucceeded: () => this.aabnNaesteFakturaOgFjernAktuelleFakturaFraListen(faktura)
        });
    }

    public tilfoejLinjeskift(faktura: Faktura): string {
        return faktura.bemaerkning.replace(/\n/g, "<br/>");
    }

    private aabnNaesteFakturaOgFjernAktuelleFakturaFraListen(faktura: Faktura): void {
        const naesteFaktura = this.findNaesteFaktura(faktura);
        this.fjernFakturaFraListen(faktura);
        setTimeout(() => this.open(naesteFaktura), 600);
    }

    private fjernFakturaFraListen(faktura: Faktura): void {
        const index = this.fakturaer.indexOf(faktura);
        this.fakturaer.splice(index, 1);
    }

    private aabnNaesteFaktura(aktuelleFaktura: Faktura): void {
        const faktura = this.findNaesteFaktura(aktuelleFaktura);
        this.open(faktura);
    }

    private findNaesteFaktura(aktuelleFaktura: Faktura): Faktura {
        const index = this.fakturaer.indexOf(aktuelleFaktura);
        const nextIndex = index < this.fakturaer.length - 1 ? index + 1 : null;
        return nextIndex !== null ? this.fakturaer[nextIndex] : null;
    }
}
